import { useMutation, useQueryClient } from 'react-query'
import { useSelector } from 'react-redux'

import { makeSelectContentTypesByModel } from '@webapp/core/stores/global'
import { permissionRepository } from '@webapp/platform/iam/data-access/repositories/PermissionRepository'
import { type ReportAccessGrantConstructor } from '@webapp/platform/iam/entities/ReportAccessGrant'
import { reportAccessGrantQueryConfig } from '@webapp/platform/iam/query-configs/reportAccessGrant'

export const useMutateGrantReportAccess = () => {
  const queryClient = useQueryClient()
  const secondaryCategoryContentType = useSelector(
    makeSelectContentTypesByModel('procurify', 'department')
  )

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: ({
      userAuthId,
      secondaryCategoryId,
    }: {
      userAuthId: number
      secondaryCategoryId: number
    }) =>
      permissionRepository.grantReportAccess({
        userAuthId,
        secondaryCategoryContentTypeId: secondaryCategoryContentType.id,
        secondaryCategoryId,
      }),
    onSuccess: (grant, { secondaryCategoryId }) => {
      // Dedup-insert at the top of the grants list (BHV-013/BHV-014) on the
      // FULL key — partial keys never match the live cache entry (ADR-5)
      const { queryKey } = reportAccessGrantQueryConfig.list({
        secondaryCategoryId,
        secondaryCategoryContentTypeId: secondaryCategoryContentType.id,
      })

      queryClient.setQueryData<ReportAccessGrantConstructor[]>(
        queryKey,
        (existing = []) =>
          existing.some((existingGrant) => existingGrant.id === grant.id)
            ? existing
            : [grant, ...existing]
      )
    },
  })

  return {
    grantReportAccess: mutateAsync,
    isGranting: isLoading,
  }
}
